export const DEFAULT_ADDITIONAL_HEIGHT_SCROLL_PRIMARY = 10;
export const DEFAULT_DATA_LIST_HEIGHT_MIDDLE = 'middle';
export const DEFAULT_DATA_LIST_HEIGHT_SMALL = 'small';
export const DEFAULT_DATA_LIST_HEIGHT_LARGE = 'large';
export const DEFAULT_ADDITIONAL_HEIGHT_SCROLL_SECONDARY = 24;
export const DEFAULT_MEDIUM_GAP_HEIGHT_TABLE_CONTAINER = 351;
